import { db, storage } from '@/firebase.js';
export default({
    state:{
        galleryUploadList: [],
        totalFiles: 0,
        doneFiles: 0,
        uploading: false
    },
    mutations:{
        selectedImages(state, e){
            state.galleryUploadList = [];
            state.doneFiles = 0;
            e.target.files.forEach(file=>{
                state.galleryUploadList.push(file)
            })
            state.totalFiles = state.galleryUploadList.length;
        },
        uploadFiles(state){
            state.uploading = true;
            state.galleryUploadList.forEach(image=>{
                let storageRef = storage.ref(`gallery/${image.name}`);
                storageRef.put(image)
                .then(snapshot=>{
                    snapshot.ref.getDownloadURL().then(url=>{
                        db.collection('gallery').doc().set({
                            name: image.name,
                            url
                        })
                        state.doneFiles = state.doneFiles+1;
                    })
                })
            })
            state.galleryUploadList = [];
            state.uploading = false;
        }
    },
    actions:{},
    getters:{}
})